import { memo } from 'react';

const PageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 21.4V2.6C4 2.26863 4.26863 2 4.6 2H16.2515C16.4106 2 16.5632 2.06321 16.6757 2.17574L19.8243 5.32426C19.9368 5.43679 20 5.5894 20 5.74853V21.4C20 21.7314 19.7314 22 19.4 22H4.6C4.26863 22 4 21.7314 4 21.4Z"
      stroke="#8E33FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 10L16 10" stroke="#8E33FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 18L16 18" stroke="#8E33FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 14L12 14" stroke="#8E33FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 2V5.4C16 5.73137 16.2686 6 16.6 6H20" stroke="#8E33FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default memo(PageIcon);
